import React, { useCallback, useEffect, useState } from "react"
import { CSSTransition } from "react-transition-group"
import i18nData from "@rogue_4/locales/zh-CN.json"
import classNames from "classnames"

import { i18n } from "@/utils/i18n"
import { useGameRestart } from "../../../store"
import { getTransitionClassnames } from "../../../utils/transition"
import Button from "../../Button"
import { useGameModalStore } from "../store"

import styles from "./index.module.less"

interface Props {
    className?: string
    style?: React.CSSProperties
}

const RestartModal: React.FC<Props> = (props) => {
    const { className, style } = props

    const [active, setActive] = useState(false)
    useEffect(() => {
        useGameModalStore.setState({
            callRestartModal: () => {
                setActive(true)
            },
        })
    }, [])

    const restart = useGameRestart()
    const handleConfirm = useCallback(() => {
        restart()
        setActive(false)
    }, [restart])

    return (
        <CSSTransition
            in={active}
            timeout={300}
            classNames={getTransitionClassnames(styles)}
        >
            <div
                className={classNames(styles.restartModal, className)}
                style={style}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.content}>
                    {i18n(i18nData, "rogue_4.game.restart.confirm")}
                </div>
                <div className={styles.action}>
                    <Button
                        size="small"
                        active={false}
                        onClick={() => setActive(false)}
                        className={styles.button}
                    >
                        {i18n(i18nData, "rogue_4.cancel")}
                    </Button>
                    <Button
                        size="small"
                        active={false}
                        onClick={handleConfirm}
                        className={styles.button}
                    >
                        {i18n(i18nData, "rogue_4.confirm")}
                    </Button>
                </div>
            </div>
        </CSSTransition>
    )
}

export default RestartModal
